var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sender-header"},[(_vm.fileList.length > 0)?_c('div',{staticClass:"file-list-container"},[_c('el-x-attachments',{attrs:{"hide-upload":true,"items":_vm.mappedFileList},on:{"delete-card":_vm.handleDeleteFile}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }